import InputDate from "@/Components/Base/Input/InputDate";
import InputPreco from "@/Components/Base/Input/InputPreco";
import ModalBase, { IModalBaseProps, ModalBaseRefType } from "@/Components/Base/ModalBase";
import Titulo from "@/Models/Financeiro/Titulo/Titulo";
import { useBuscar, useTituloDuplicar } from "@/Services/Financeiro/Titulo/TituloService";
import { Form, FormProps, Col, InputNumber, Card, Flex, Row, notification } from "antd";
import { useRef, useMemo } from "react";
import dayjs from 'dayjs';
import TelaCarregamento from "@/Components/Base/Carregamento/TelaCarregamento";
import { PropriedadesDeNotificacao } from "@/Utils/Notificacoes";

export interface ITituloDublicarFormModalProps extends IModalBaseProps {
    codTituloBase:number;
}

export type TituloDublicarFormType = {
    quantidade:number;
    parcelas:number[];
    tituloBase:Titulo;
    titulos:Titulo[];
}

export interface ITituloDublicarFormBasicProps extends FormProps<TituloDublicarFormType> {

}

function TituloDublicarFormBasic({
    layout,
    autoComplete,
    component,
    initialValues,
    form : formParam,
    ...props
}:ITituloDublicarFormBasicProps) {    
    const [newForm] = Form.useForm<TituloDublicarFormType>();
    const form = formParam ?? newForm;

    const quantidadeForm = Form.useWatch("quantidade", form);
    const parcelas = useMemo(() => new Array(quantidadeForm ?? 0).fill(undefined).map((_, i) => i), [quantidadeForm]);
    const carregando = initialValues?.tituloBase === null && initialValues?.tituloBase === undefined;

    return <TelaCarregamento ativo={carregando}>
        <Form<TituloDublicarFormType>
            {...props}
            form={form}
            layout={layout ?? "vertical"}
            autoComplete={autoComplete ?? "off"}
            initialValues={{
                quantidade : 1,
                ...(initialValues ?? {})
            }}
        >
            <Form.Item<TituloDublicarFormType> name={"tituloBase"} hidden={true} />

            <Col xs={24} sm={12} md={8} lg={5} xl={4} xxl={3}>
                <Form.Item<TituloDublicarFormType> label="Quantidade" name={["quantidade"]} rules={[{ required : true }]}>
                    <InputNumber addonBefore={<>Nº</>} placeholder="Quantidade" min={0} max={32} />
                </Form.Item>
            </Col>

            {!carregando && <Form.List name={"titulos"}>
                {(fields) => (
                    <Flex vertical={true} gap={8}>
                        {
                            parcelas.map(index => (
                                <Card
                                    size="small"
                                    title={`Parcela ${index + 1}`}
                                    key={index}
                                >
                                    <Row gutter={8} wrap>
                                        <Col xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}>
                                            <Form.Item<TituloDublicarFormType> label={"Vencimento"} name={[index, "dataVencimento"]} initialValue={dayjs(initialValues?.tituloBase?.dataVencimento).add(index + 1, "month")} rules={[{ required: true }]}>
                                                <InputDate />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={4}>
                                            <Form.Item<TituloDublicarFormType> label={"Valor base (R$)"} name={[index, "valorBase"]} initialValue={initialValues?.tituloBase?.valorBase} rules={[{ required: true }]}>
                                                <InputPreco
                                                    placeholder="Valor base (R$)"
                                                    addonBefore={<>R$</>}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                            ))
                        }
                    </Flex>
                )}
            </Form.List>}
        </Form>
    </TelaCarregamento>;
}

export default function TituloDublicarFormModal({
    codTituloBase,
    width,
    textButtonOpen,
    propsButtonOpen,
    okText,
    footer,
    ...props
}:ITituloDublicarFormModalProps) {
    propsButtonOpen = propsButtonOpen ?? {};
    propsButtonOpen.style = propsButtonOpen.style ?? {};

    const refModal = useRef<ModalBaseRefType|null>(null);
    const [ form ] = Form.useForm<TituloDublicarFormType>();
    
    const {
        data
    } = useBuscar({
        codigo: codTituloBase ?? 0,
        enabled: codTituloBase > 0,
    });

    const {
        mutate,
        isPending
    } = useTituloDuplicar({
        onSuccess : () => {
            refModal.current?.fechar();
            notification.success({
                ...PropriedadesDeNotificacao["Sucesso"],
                message : "Parcelas duplicadas com sucesso."
            });
        }
    });

    return <ModalBase
        {...props}
        ref={refModal}
        title={textButtonOpen ?? "Duplicar"}
        width={width ?? "85vw"}
        destroyOnClose={true}
        textButtonOpen={textButtonOpen ?? "Dup."}
        propsButtonOpen={{
            ...propsButtonOpen,
            type : propsButtonOpen.type ?? "dashed",
            size : propsButtonOpen.size ?? "small",
            style : {
                ...propsButtonOpen.style,
                width : propsButtonOpen.style.width ?? "min-content"
            }
        }}
        onOk={() => form.submit()}
        okText={okText ?? "Duplicar"}
        confirmLoading={isPending}
    >
        <TituloDublicarFormBasic 
            form={form} 
            onFinish={(dados) => {
                mutate({
                    codTituloBase : dados.tituloBase.codigo ?? -1,
                    titulos : dados.titulos ?? []
                })
            }} 
            initialValues={{
                tituloBase : data?.data
            }}
        />
    </ModalBase>; 
}